import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import ButtonBase from '../../Buttons/ButtonBase';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import AuthButton from '../../Buttons/AuthButton';
import ScheduleDivided from '../../Profile/Schedule/ScheduleDivided';
import ScheduleContinuous from '../../Profile/Schedule/ScheduleContinuous';
import { addSchedule, updateSchedule } from '../../../store/actions/UserAction';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

const continuousData = {
  Lunes: { open: true, start: '09:00', end: '18:00' },
  Martes: { open: true, start: '09:00', end: '18:00' },
  Miércoles: { open: true, start: '09:00', end: '18:00' },
  Jueves: { open: true, start: '09:00', end: '18:00' },
  Viernes: { open: true, start: '09:00', end: '18:00' },
  Sábado: { open: true, start: '09:00', end: '18:00' },
  Domingo: { open: true, start: '09:00', end: '18:00' },
};

const dividedData = {
  Lunes: {
    open: true,
    morning: { start: '09:00', end: '13:00' },
    evening: { start: '14:00', end: '18:00' },
  },
  Martes: {
    open: true,
    morning: { start: '09:00', end: '13:00' },
    evening: { start: '14:00', end: '18:00' },
  },
  Miércoles: {
    open: true,
    morning: { start: '09:00', end: '13:00' },
    evening: { start: '14:00', end: '18:00' },
  },
  Jueves: {
    open: true,
    morning: { start: '09:00', end: '13:00' },
    evening: { start: '14:00', end: '18:00' },
  },
  Viernes: {
    open: true,
    morning: { start: '09:00', end: '13:00' },
    evening: { start: '14:00', end: '18:00' },
  },
  Sábado: {
    open: true,
    morning: { start: '09:00', end: '13:00' },
    evening: { start: '14:00', end: '18:00' },
  },
  Domingo: {
    open: true,
    morning: { start: '09:00', end: '13:00' },
    evening: { start: '14:00', end: '18:00' },
  },
};

const ScheduleForm = ({
  scheduleData,
  typeSchedule,
  addSchedule,
  updateSchedule,
  uid,
  setFlagEdit,
  flagEdit,
  setFeedbackMessage,
  handleOpenTrophieModal,
  trophie,
  showLoading, 
  hideLoading,
}) => {

  const handleSubmit = (values, { setSubmitting }) => {
    const arrayValues = Object.values(values);
    const boolValues = arrayValues.every((elem) => elem);
    showLoading();
    setSubmitting(false);
    console.log('boolValues', boolValues)

    !flagEdit ?
      addSchedule(uid, values, boolValues, typeSchedule)
      .then((res) => {
        hideLoading();
        setFlagEdit(false);
        
        !trophie && handleOpenTrophieModal()
        
        trophie && setFeedbackMessage({
          open: true,
          message: 'Tus cambios se han guardado con éxito',
          variant: 'success',
        });
        scroller.scrollTo('TopSchedule', {
          duration: 1000,
          smooth: true,
          offset: -100,
        });
        
        
      })
      .catch(error => {
        console.log(error)
      })
    : updateSchedule(uid, values, boolValues, typeSchedule)
      .then((res) => {
        hideLoading();
        setFlagEdit(false);
                
        trophie && setFeedbackMessage({
          open: true,
          message: 'Tus cambios se han guardado con éxito',
          variant: 'success',
        });
        scroller.scrollTo('TopSchedule', {
          duration: 1000,
          smooth: true,
          offset: -100,
        });
        
        
      })
      .catch(error => {
        console.log(error)
      })
    
  };

  const handleCancel = (event) => {
    event.preventDefault();
    setFlagEdit(false);
    scroller.scrollTo('TopSchedule', {
      duration: 1000,
      smooth: true,
      offset: -100,
    });
  };

  return (
    <>
        {typeSchedule === 'continuous' && (
          <Formik
            initialValues={
              scheduleData &&
              scheduleData.type &&
              scheduleData.type === 'continuous'
                ? scheduleData.scheduleDays
                : continuousData
            }
            onSubmit={handleSubmit}
            render={(props) => (
              <ScheduleContinuous
                handleCancel={handleCancel}
                flagEdit={flagEdit}
                {...props}
              />
            )}
          />
        )}

        {typeSchedule === 'divided' && (
          <Formik
            initialValues={
              scheduleData &&
              scheduleData.type &&
              scheduleData.type === 'divided'
                ? scheduleData.scheduleDays
                : dividedData
            }
            onSubmit={handleSubmit}
            render={(props) => (
              <ScheduleDivided
                handleCancel={handleCancel}
                flagEdit={flagEdit}
                {...props}
              />
            )}
          />
        )}
    </>
  );
};

const mapStateToProps = (state) => ({
  uid: state.authClient.uid,
  scheduleData: state.authClient.schedule,
  trophie: state.authClient.awardPerfil.schedule,
});

const mapDispatchToProps = (dispatch) => ({
  addSchedule: (uid, values, boolValues, typeSchedule) =>
    dispatch(addSchedule(uid, values, boolValues, typeSchedule)),
  updateSchedule: (uid, values, boolValues, typeSchedule) =>
    dispatch(updateSchedule(uid, values, boolValues, typeSchedule)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleForm);
